var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFund({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07617 7.62109L16.9223 7.62109",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23002 13.8846H3.07617V3.5H16.9223V13.8846H12.7685",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.002 9.9082L10.002 16.7826M10.002 9.9082L7.92578 12.0064M10.002 9.9082L12.0782 12.0064",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFund);
export default __webpack_public_path__ + "static/media/fund.2cd51407ec48c85fd3607131da0cb1ef.svg";
export { ForwardRef as ReactComponent };